export default "__VITE_ASSET__Bu2nbAUf__"